export const colors = {
    colorPrimary: '#1A5AFF',
    // colorPrimary: 'red',
    colorWarning: '#F0DB0A',
    colorSuccess: '#52C41A',
    colorError: '#F5222D'
}